import PropTypes from 'prop-types';

// Styles
import { Typography } from '@mui/material';
import styled from 'styled-components';
import colors from 'styles/colors';
import sizes from 'styles/sizes';

const EntryField = styled.input`
  color: ${colors.functional.softGrey};
  border: 1.5px solid ${colors.functional.borderGrey};
  border-radius: 5px;
  font-size: 16px;
  height: 50px;
  margin: 10px 0;
  padding: 13px 15px;
  width: 100%;
  @media (min-width: ${sizes.media.tabletPortrait}px) {
    width: 348px;
  }
`;

const Label = styled(Typography)`
  color: ${props => props.color};
  width: ${props => (props.error ? 'auto' : '100%')};

  @media (min-width: ${sizes.media.tabletPortrait}px) {
    position: ${props => (props.error ? 'absolute' : 'unset')};
    top: 110px;
  }
`;

const Input = ({
  placeholder,
  label,
  isInvalid,
  errorMessage,
  onChange,
  onKeyDown,
  name,
  value,
}) => {
  return (
    <>
      <Label variant="label2" component="p" color={colors.functional.softGrey}>
        {label}
      </Label>
      <EntryField
        placeholder={placeholder}
        onChange={onChange}
        onKeyDown={onKeyDown}
        name={name}
        value={value}
      />
      {isInvalid && (
        <Label
          variant="label3"
          component="p"
          id="error-message"
          color={colors.functional.errorRed}
          error
        >
          {errorMessage}
        </Label>
      )}
    </>
  );
};

Input.propTypes = {
  placeholder: PropTypes.string,
  label: PropTypes.string,
  isInvalid: PropTypes.bool,
  errorMessage: PropTypes.string,
  onChange: PropTypes.func,
  onKeyDown: PropTypes.func,
  name: PropTypes.string,
  value: PropTypes.string,
};

export default Input;
